import { Banner } from "../../molecules";
import { Page } from "../../atoms";
import { useEffect } from "react";

const Blog = () => {

  useEffect(() => {
    if (document) {
      const headElement = document.querySelector("head");
      if (!headElement) return;

      const dibScript = document.createElement("script");
      dibScript.src = `https://io.dropinblog.com/embedjs/9e48d6ec-4806-443b-b221-1b4c8a58268e.js`;
      dibScript.async = true;

      headElement.appendChild(dibScript);
    }
  }, []);

  return (
    <Page title="Blog">
      <Banner title="Blog" />
      <div id="dib-posts" />
    </Page>
  );
};

export default Blog;
